import { useState } from 'react';

import { Switch, FormControlLabel } from '@mui/material';

import strings from 'constants/index';

export const useTbdCompetitorsSwitch = () => {
  const [showOnlyTbdCompetitors, setOnlyTbdCompetitors] = useState(false);

  const TbdCompetitorsSwitch = () => (
    <FormControlLabel
      control={
        <Switch
          data-testid="tbd-competitors-switch"
          aria-label="tbd-competitors-view"
          checked={showOnlyTbdCompetitors}
          onChange={() => setOnlyTbdCompetitors(!showOnlyTbdCompetitors)}
          name="tbdCompetitorsView"
        />
      }
      label={strings.show_tbd_competitors_data}
    />
  );

  return { showOnlyTbdCompetitors, TbdCompetitorsSwitch };
};
